import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { registerServiceWorker } from "./push";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
reportWebVitals();

// Permite instalar la app y recibir push con la app cerrada
window.addEventListener("load", () => {
  registerServiceWorker().catch(() => {
    // Sin service worker la app funciona igual, sólo que no se puede instalar
  });
});